import API from '../../shared/Config/API';
import APIEndpoints from '../../shared/Config/APIEndpoints';

const getPermissionsForRole = async (role) => {
  const response = API.get(APIEndpoints.GET_ALL_PERMISSIONS_FOR_ROLE + '/' + role);
  return response;
};

export const permissionsAPI = {
  getPermissionsForRole,
};
